@if(loading()) {
<h2 class="loren-asset-details-alarms-table-title">
  {{ "asset_details.alarms" | transloco }}
</h2>
<div class="loren-alarms-table-spinner">
  <mat-spinner></mat-spinner>
</div>
} @else {
<div class="centered-between">
  <h2 class="loren-asset-details-alarms-table-title">
    {{ "asset_details.alarms" | transloco }} (<span class="font-weight-bold">{{
      totalNumOfAlarms()
    }}</span
    >)
  </h2>
    @if (hasAlarmsToShow()) {
        <button matButton="filled" (click)="clearAllFilters()" class="btn-secondary">
            {{ "alarms.clear_filters" | transloco }}
        </button>
    }
</div>

@if(isHandset && hasAlarmsToShow()) {
<div class="loren-asset-details-alarms-table-mobile-filters">
  <button matButton="filled" [matMenuTriggerFor]="parametersFilters" >
    {{ "alarms.filter_by_parameter" | transloco }}
  </button>
  <button matButton="filled" [matMenuTriggerFor]="startFilters">
    {{ "alarms.filter_by_start" | transloco }}
  </button>
  <button matButton="filled" [matMenuTriggerFor]="statusFilters">
    {{ "alarms.filter_by_status" | transloco }}
  </button>
</div>
} @if(!hasAlarmsToShow() || alarmsError()) {
<mat-card class="loren-alarms-none">
  <div class="vertically-centered loren-alarms-none-content">
    <mat-icon class="loren-alarms-none-icon" svgIcon="no_data"></mat-icon>
    <span class="loren-alarms-none-text"
      >{{
        !hasAlarmsToShow()
          ? ("asset_details.no_alarms" | transloco)
          : ("alarms.error" | transloco)
      }}
    </span>
  </div>
</mat-card>
} @else if (!alarms().length) {
<div class="loren-alarms-table-container">
  @if(!isHandset) {
  <table
    #alarmsTable
    mat-table
    class="loren-alarms-table"
    [dataSource]="alarms()">
    <ng-container matColumnDef="rowNum">
      <th
        mat-header-cell
        class="loren-alarms-table-header"
        *matHeaderCellDef></th>
    </ng-container>

    <ng-container [matColumnDef]="alarmColumns.PARAMETER">
      <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
        {{ "alarms.parameter_value" | transloco }}
        <mat-icon class="loren-alarms-table-header-icon"
          >import_export</mat-icon
        >
        <mat-icon
          class="loren-alarms-table-header-icon"
          [matMenuTriggerFor]="parametersFilters"
          #menuTrigger
          >filter_alt</mat-icon
        >
      </th>
    </ng-container>

    <ng-container [matColumnDef]="alarmColumns.START">
      <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
        {{ "alarms.start" | transloco }}
        <mat-icon class="loren-alarms-table-header-icon"
          >import_export</mat-icon
        >
        <mat-icon
          class="loren-alarms-table-header-icon"
          [matMenuTriggerFor]="startFilters"
          #menuTrigger
          >filter_alt</mat-icon
        >
      </th>
    </ng-container>

    <ng-container [matColumnDef]="alarmColumns.STATUS">
      <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
        {{ "alarms.status" | transloco }}
        <mat-icon class="loren-alarms-table-header-icon"
          >import_export</mat-icon
        >
        <mat-icon
          class="loren-alarms-table-header-icon"
          [matMenuTriggerFor]="statusFilters"
          #menuTrigger
          >filter_alt</mat-icon
        >
      </th>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  }
  <mat-card class="loren-alarms-none">
    <div class="vertically-centered loren-alarms-none-content">
      <mat-icon class="loren-alarms-none-icon" svgIcon="no_data"></mat-icon>
      <span class="loren-alarms-none-text"
        >{{ "alarms.no_alarms_with_filters" | transloco }}
      </span>
    </div>
  </mat-card>
</div>
} @else { @if(isHandset) {@for(alarm of alarms(); track alarm) {
<div class="loren-table-mobile">
  <div class="loren-table-mobile-header">
    <span style="grid-column: 1 / span 2">{{
      alarm[alarmColumns.START] | lorenDate
    }}</span>
  </div>
  <div class="loren-table-mobile-content">
    <span class="loren-table-mobile-content--key">{{
      "alarms.parameter" | transloco
    }}</span>
    <span>{{ alarm[alarmColumns.PARAMETER] }}</span>
    <span class="loren-table-mobile-content--key">{{
      "alarms.value" | transloco
    }}</span>
    <span>{{ alarm.value }}</span>
    <span class="loren-table-mobile-content--key">{{
      "alarms.status" | transloco
    }}</span>
    @if(alarm[alarmColumns.STATUS] === 'ACTIVE') {
    <mat-icon style="color: #e11d48" [title]="'alarms.active' | transloco"
      >error_outline</mat-icon
    >
    } @else {
    <mat-icon style="color: #00966e" [title]="'alarms.inactive' | transloco"
      >check</mat-icon
    >
    }
  </div>
</div>
} } @else {
<div class="loren-alarms-table-container">
  <table
    #alarmsTable
    mat-table
    class="loren-alarms-table"
    [dataSource]="alarms()">
    <ng-container matColumnDef="rowNum">
      <th
        mat-header-cell
        class="loren-alarms-table-header"
        *matHeaderCellDef></th>
      <td
        mat-cell
        class="loren-alarms-table-cell loren-alarms-table-cell-num"
        *matCellDef="let i = index">
        {{ +i + 1 }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="alarmColumns.PARAMETER">
      <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
        {{ "alarms.parameter_value" | transloco }}
        <mat-icon
          class="loren-alarms-table-header-icon"
          [ngClass]="{
            'loren-alarms-table-header-sorted': sorted()[alarmColumns.PARAMETER]
          }"
          (click)="sort(alarmColumns.PARAMETER)"
          >import_export</mat-icon
        >
        <mat-icon
          class="loren-alarms-table-header-icon"
          [matMenuTriggerFor]="parametersFilters"
          #menuTrigger
          >filter_alt</mat-icon
        >
      </th>
      <td mat-cell class="loren-alarms-table-cell" *matCellDef="let element">
        <div class="loren-alarms-table-parameter">
          <span>{{ element[alarmColumns.PARAMETER] }}</span>
          <span class="loren-alarms-table-value bold">{{ element.value }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container [matColumnDef]="alarmColumns.START">
      <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
        {{ "alarms.start" | transloco }}
        <mat-icon
          class="loren-alarms-table-header-icon"
          [ngClass]="{
            'loren-alarms-table-header-sorted': sorted()[alarmColumns.START]
          }"
          (click)="sort(alarmColumns.START)"
          >import_export</mat-icon
        >
        <mat-icon
          class="loren-alarms-table-header-icon"
          [matMenuTriggerFor]="startFilters"
          #menuTrigger
          >filter_alt</mat-icon
        >
      </th>
      <td
        *matCellDef="let element"
        mat-cell
        class="loren-alarms-table-cell loren-alarms-table-cell-date">
        {{ element[alarmColumns.START] | lorenDate }}
      </td>
    </ng-container>

    <ng-container [matColumnDef]="alarmColumns.STATUS">
      <th
        mat-header-cell
        class="loren-alarms-table-header"
        style="text-align: center"
        *matHeaderCellDef>
        {{ "alarms.status" | transloco }}
        <mat-icon
          class="loren-alarms-table-header-icon"
          [ngClass]="{
            'loren-alarms-table-header-sorted': sorted()[alarmColumns.STATUS]
          }"
          (click)="sort(alarmColumns.STATUS)"
          >import_export</mat-icon
        >
        <mat-icon
          class="loren-alarms-table-header-icon"
          [matMenuTriggerFor]="statusFilters"
          #menuTrigger
          >filter_alt</mat-icon
        >
      </th>
      <td mat-cell class="loren-alarms-table-cell" *matCellDef="let element">
        <div style="text-align: center">
          @if(element[alarmColumns.STATUS] === 'ACTIVE') {
          <mat-icon style="color: #e11d48" [title]="'alarms.active' | transloco"
            >error_outline</mat-icon
          >
          } @else {
          <mat-icon
            style="color: #00966e"
            [title]="'alarms.inactive' | transloco"
            >check</mat-icon
          >
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>
} } }
<loren-home-alarms-table-actions
  [totalNumOfAlarms]="totalNumOfAlarms()"
  [alarmsOnPage]="alarms().length"
  (tableScrolled)="scrollTo($event)"
  (elChangedStatus)="handleElFocus($event)"
  (alarmsIncreased)="alarmsIncreasedHandler($event)"
  (alarmsDecreased)="alarmsDecreasedHandler($event)"
  (selectionChanged)="selectionChangedHandler($event)">
</loren-home-alarms-table-actions>

<mat-menu #parametersFilters="matMenu">
  <ng-template matMenuContent>
    <loren-filters
      [placeholder]="'alarms.search_parameters' | transloco"
      [initiallySelected]="activeFilters()[alarmFilters.ASSET_METERING_TYPE]"
      [items]="parametersFilter"
      (selectionSubmitted)="filter(alarmFilters.ASSET_METERING_TYPE, $event)">
    </loren-filters>
  </ng-template>
</mat-menu>
<mat-menu #startFilters="matMenu">
  <ng-template matMenuContent>
    <loren-filters
      [initiallySelected]="activeFilters()[alarmFilters.START_TIME]"
      [items]="startTimeFilters"
      [placeholder]="'alarms.start' | transloco"
      [showSearch]="false"
      [withNumber]="1"
      (selectionSubmitted)="filter(alarmFilters.START_TIME, $event)">
    </loren-filters>
  </ng-template>
</mat-menu>

<mat-menu #statusFilters="matMenu">
  <ng-template matMenuContent>
    <loren-filters
      [initiallySelected]="activeFilters()[alarmFilters.STATUS]"
      [items]="statusFilter"
      [placeholder]="'alarms.status' | transloco"
      [showSearch]="false"
      [withNumber]="1"
      (selectionSubmitted)="filter(alarmFilters.STATUS, $event)">
    </loren-filters>
  </ng-template>
</mat-menu>
